import { actions } from './purposeHospitalization/actions'
import { getters } from './purposeHospitalization/getters'
import { state } from './purposeHospitalization/state'
import { mutations } from './purposeHospitalization/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
